(function ($) {
  "use strict";
  $(function () {
    window.customSelectProductsGarnish = function () {
      var $customSelectProductsGarnish = window.customSelect('.garnish__select', {
        containerClass: 'garnish__container',
        openerClass: 'garnish__opener',
        panelClass: 'garnish__panel',
        optionClass: 'garnish__option',
        optgroupClass: 'custom-select-optgroup',
        isSelectedClass: 'is-selected',
        hasFocusClass: 'has-focus',
        isDisabledClass: 'is-disabled',
        isOpenClass: 'is-open'
      });
      if ($customSelectProductsGarnish.length) {
        $customSelectProductsGarnish.forEach(function (item, key) {
          $customSelectProductsGarnish[key]
            .container
            .addEventListener(
              'custom-select:close',
              (e) => {
                window.changeOffer();
              }
            );
        });
      }

      var $customSelectProductGarnish = window.customSelect('.x-product-garnish-select', {
        containerClass: 'product__garnish-container',
        openerClass: 'product__garnish-opener',
        panelClass: 'product__garnish-panel',
        optionClass: 'product__garnish-option',
        optgroupClass: 'custom-select-optgroup',
        isSelectedClass: 'is-selected',
        hasFocusClass: 'has-focus',
        isDisabledClass: 'is-disabled',
        isOpenClass: 'is-open'
      });
      if ($customSelectProductGarnish.length) {
        $customSelectProductGarnish.forEach(function (item, key) {
          $customSelectProductGarnish[key]
            .container
            .addEventListener(
              'custom-select:close',
              (e) => {
                window.changeOffer();
              }
            );
        });
      }
    }

    window.updateBranchesGroupProduct = function (stopList = false) {
      if ($(document).find('.x-branches-group-available').length) {
        if ($(document).find('.x-branches-group-available-element').length) {
          let id = $(document).find('.x-branches-group-available-element').data('id');
          $.ajax({
            type: "POST",
            url: "/ajax/productAvailableBranchesGroup.php",
            data: {
              id: id
            },
            dataType: "json",
            success: function (data) {
              let $box = $(document).find('.x-product-box');
              let classB = 'product__branches-group-no-available';
              if ($box.parents('.x-dinner-box').length) {
                $box = $box.parents('.x-dinner-box');
                classB = 'product__branches-group-no-available-combo';
              }
              if (!data.success) {
                $box.addClass(classB);
              } else {
                $box.removeClass(classB);
              }
              if (stopList) {
                window.stopListProductsAndOffers();
              }
            }
          });
        }
      }
    }
    window.updateBranchesGroupProduct();

    window.updateBranchesGroup = function () {
      if ($(document).find('.x-branches-group-available').length) {
        if (
          $(document).find('.x-branches-group-available-section').length
          &&
          !$(document).find('.x-combo-section').length
        ) {
          $.ajax({
            type: "POST",
            url: "",
            dataType: 'html',
            processData: false,
            contentType: false,
            success: function (data) {
              $(document).find('.x-branches-group-available-section').html($('<div />').html(data).find('.x-branches-group-available-section').html());
              window.stopListProductsAndOffers();
              window.customSelectProductsGarnish();
            }
          });
        } else if ($(document).find('.x-branches-group-available-element').length) {
          window.updateBranchesGroupProduct(true);
        } else {
          window.stopListProductsAndOffers();
        }
      } else {
        window.stopListProductsAndOffers();
      }
    }

  });
})(jQuery);



